import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tab, Nav, Col, Badge } from 'react-bootstrap';
import { Filter, FilterBox } from '../../widgets';
import { setLoadQueueFilterIds, setLoadQueueFilters } from '../../../actions/load';
import { validateCollections } from '../../../helpers/common';

const LoadQueueFilter = () => {
	const initialState = {
		fields: [],
		source: [],
		target: [],
		crew: []
	};

	const loadQueueFilters = useSelector(state => state.load.loadQueueFilters);
	const loadQueueList = useSelector(state => state.load.loadQueueList.data);

	const [state, setState] = useState({
		...initialState,
		isOpen: false,
		filters: { ...initialState },
		previous: { ...initialState }
	});

	const dispatch = useDispatch();

	const setStateX = (stateProps) => {
		const updatedState = { ...state, ...stateProps };
		setState(updatedState);
		dispatch(setLoadQueueFilters(updatedState.filters));
	}

	const handleApply = () => {
		const { filters } = state;
		let foundItems = loadQueueList;

		if (filters && validateCollections(filters.fields))
			foundItems = foundItems.filter(e => filters && filters.fields.indexOf(e.fieldGeoShapeId ? e.fieldGeoShapeId : "-1") >= 0);

		if (filters && validateCollections(filters.source))
			foundItems = foundItems.filter(e => filters && filters.source.indexOf(e.sourceEquipmentGroupId ? e.sourceEquipmentGroupId : "-1") >= 0);

		if (filters && validateCollections(filters.target))
			foundItems = foundItems.filter(e => filters && filters.target.indexOf(e.targetEquipmentGroupId ? e.targetEquipmentGroupId : "-1") >= 0);

		if (filters && validateCollections(filters.crew))
			foundItems = foundItems.filter(e => filters && filters.crew.indexOf(e.crewUuid ? e.crewUuid : "-1") >= 0);

		dispatch(setLoadQueueFilterIds(foundItems.map(e => e.loadActivityId)));
		const updatedState = { ...state, isOpen: false, previous: state.filters };
		setStateX(updatedState);
	}

	const bindOptions = () => {
		const fields = {}, source = {}, target = {}, crew = {};

		for (const item of loadQueueList) {
			const fieldId = item.fieldGeoShapeId ? item.fieldGeoShapeId : -1;
			if (fields[fieldId]) continue;
			if (fieldId !== -1) fields[fieldId] = { name: item.fieldGeoShapeName, order: 1 };
			else fields[fieldId] = { name: "Unknown", order: 0 };
		}

		for (const item of loadQueueList) {
			const sourceId = item.sourceEquipmentGroupId ? item.sourceEquipmentGroupId : -1;
			if (source[sourceId]) continue;
			if (sourceId !== -1) source[sourceId] = { name: item.sourceEquipmentGroupName, order: 1 };
			else source[sourceId] = { name: "Unknown", order: 0 };
		}

		for (const item of loadQueueList) {
			const targetId = item.targetEquipmentGroupId ? item.targetEquipmentGroupId : -1;
			if (target[targetId]) continue;
			if (targetId !== -1) target[targetId] = { name: item.targetEquipmentGroupName, order: 1 };
			else target[targetId] = { name: "Unknown", order: 0 };
		}

		for (const item of loadQueueList) {
			const crewId = item.crewUuid ? item.crewUuid : -1;
			if (crew[crewId]) continue;
			if (crewId !== -1) crew[crewId] = { name: item.crewName, order: 1 };
			else crew[crewId] = { name: "Unknown", order: 0 };
		}
		const sortOrder = (a, b) => a.order - b.order;
		const updatedState = {
			...state,
			fields: Object.keys(fields).map(id => ({ id, ...fields[id] })).sort(sortOrder),
			source: Object.keys(source).map(id => ({ id, ...source[id] })).sort(sortOrder),
			target: Object.keys(target).map(id => ({ id, ...target[id] })).sort(sortOrder),
			crew: Object.keys(crew).map(id => ({ id, ...crew[id] })).sort(sortOrder),
			filters: loadQueueFilters ? loadQueueFilters || {} : {}
		};
		setStateX(updatedState);
	}

	const handleSelect = (item, e, name) => {
		const id = item.id;
		const { checked } = e.target;
		const validatedFilter = state.filters && state.filters[name] ? state.filters[name] : [];
		const selected = [...validatedFilter];
		const indexOf = selected.indexOf(id);
		const updatedState = { ...state, filters: { ...state.filters, [name]: selected } };
		if (checked && indexOf < 0) selected.push(id);
		else if (!checked && indexOf >= 0) selected.splice(indexOf, 1);

		setState(updatedState);
	}

	const handleClear = () => {
		dispatch(setLoadQueueFilterIds(null));
		const updatedState = { ...state, filters: { ...initialState }, previous: { ...initialState } };
		setStateX(updatedState);
	}

	const toggle = (isOpen) => {
		const updatedState = { ...state, isOpen }
		if (!isOpen && state.isOpen) {
			setStateX(updatedState);
		}

		else setStateX(updatedState);
	}

	const getFilterCount = (name) => {
		if (name)
			return state.filters && state.filters[name] && state.filters[name].length > 0 ?
				state.filters && state.filters[name] && state.filters[name].length : '';
		else {
			let total = 0;
			for (const key in state.filters) total += (state.filters[key] && state.filters[key].length > 0 ? 1 : 0);
			return total > 0 ? total : null;
		}
	}

	const totalFilters = getFilterCount();

	useEffect(() => {
		if (loadQueueFilters) {
			const updatedState = { ...state, filters: loadQueueFilters.filters, previous: loadQueueFilters, }
			setState(updatedState);
		}
		bindOptions(true);
	}, []);

	useEffect(() => {
		const updatedState = {
			...state,
			...initialState,
			isOpen: false,
			filters: { ...initialState },
			previous: { ...initialState },
		};
		if (!loadQueueFilters) {
			setStateX(updatedState);
		}
	}, [loadQueueFilters]);

	useEffect(() => {
		if (!loadQueueList) return;

		if (validateCollections(loadQueueList)) {
			handleApply();
		}
		bindOptions();
	}, [loadQueueList]);

	return (
		<Filter show={state.isOpen} onToggle={toggle} drop={"down"}>
			<Filter.Toggle>
				{totalFilters && <Badge variant="warning" className="badge-filter-count">{totalFilters}</Badge>}
			</Filter.Toggle>
			<FilterBox>
				<Tab.Container defaultActiveKey="first">
					<FilterBox.Body>
						<Col sm={4} className="mt-2 pr-1 pl-0">
							<Nav variant="pills" className="flex-column">
								<Nav.Item>
									<Nav.Link eventKey="first">
										Crews
										<span className="filter-count">{getFilterCount("crew")}</span>
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link eventKey="second">
										Fields
										<span className="filter-count">{getFilterCount("fields")}</span>
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link eventKey="third">
										Target EG
										<span className="filter-count">{getFilterCount("target")}</span>
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link eventKey="fourth">
										Source EG
										<span className="filter-count">{getFilterCount("source")}</span>
									</Nav.Link>
								</Nav.Item>
							</Nav>
						</Col>
						<Col lg={8} className='px-0'>
							<Tab.Content className="ml-4 mt-2">
								<Tab.Pane eventKey="first">
									<Filter.Options options={state.crew} selected={state.filters && state.filters.crew}
										keyname={{ value: "id", label: "name" }}
										onSelect={(item, e) => handleSelect(item, e, "crew")} />
								</Tab.Pane>
								<Tab.Pane eventKey="second">
									<Filter.Options options={state.fields} selected={state.filters && state.filters.fields}
										keyname={{ value: "id", label: "name" }}
										onSelect={(item, e) => handleSelect(item, e, "fields")} />
								</Tab.Pane>
								<Tab.Pane eventKey="third">
									<Filter.Options options={state.target} selected={state.filters && state.filters.target}
										keyname={{ value: "id", label: "name" }}
										onSelect={(item, e) => handleSelect(item, e, "target")} />
								</Tab.Pane>
								<Tab.Pane eventKey="fourth">
									<Filter.Options options={state.source} selected={state.filters && state.filters.source}
										keyname={{ value: "id", label: "name" }}
										onSelect={(item, e) => handleSelect(item, e, "source")} />
								</Tab.Pane>
							</Tab.Content>
						</Col>
					</FilterBox.Body>
					<FilterBox.Footer>
						<Filter.ClearButton onClick={handleClear} />
						<Filter.ApplyButton onClick={handleApply} />
					</FilterBox.Footer>
				</Tab.Container>
			</FilterBox>
		</Filter>);
}

export default LoadQueueFilter;